import Api from 'api'

const config = {
  baseURL: '/api/app/v1/advertisers',
}
const api = new Api(config)

api.fetchAll = ({ ...rest }) => api.get('', { ...rest })

api.fetchById = ({ id, ...rest }) => api.get(`/${id}`, { ...rest })

api.create = ({ ...rest }) => api.post('', { ...rest })

api.update = ({ id, ...rest }) => api.patch(`/${id}`, { ...rest })

api.activate = ({ id, ...rest }) => api.post(`/${id}/activate`, { ...rest })

api.archive = ({ id, ...rest }) => api.post(`/${id}/archive`, { ...rest })

export default api
